import { createContext, useContext, useState, useCallback, useMemo } from 'react';

const BookingContext = createContext();

export const useBooking = () => {
  const context = useContext(BookingContext);
  if (!context) {
    throw new Error('useBooking must be used within BookingProvider');
  }
  return context;
};

export const BookingProvider = ({ children }) => {
  const [searchCriteria, setSearchCriteria] = useState({
    pickupLocation: '',
    pickupDate: null,
    pickupTime: '11:00',
    returnLocation: '',
    returnDate: null,
    returnTime: '11:00',
    returnToDifferentLocation: false
  });

  const [selectedVehicle, setSelectedVehicle] = useState(null);

  const [quoteData, setQuoteData] = useState(null);

  const [bookingDetails, setBookingDetails] = useState({
    selectedInsurances: {},
    additionals: {},
    paymentMethod: 'credit',
    formData: {
      firstName: '',
      lastName: '',
      documentType: 'DNI',
      documentNumber: '',
      street: '',
      number: '',
      postalCode: '',
      country: 'Argentina',
      city: '',
      email: '',
      phone: ''
    }
  });

  const updateSearchCriteria = useCallback((criteria) => {
    setSearchCriteria(prev => ({ ...prev, ...criteria }));
  }, []);

  const updateSelectedVehicle = useCallback((vehicle) => {
    setSelectedVehicle(vehicle);
  }, []);

  const updateQuoteData = useCallback((data) => {
    setQuoteData(data);
  }, []);

  const updateBookingDetails = useCallback((details) => {
    setBookingDetails(prev => ({ ...prev, ...details }));
  }, []);

  const resetBooking = useCallback(() => {
    setSearchCriteria({
      pickupLocation: '',
      pickupDate: null,
      pickupTime: '11:00',
      returnLocation: '',
      returnDate: null,
      returnTime: '11:00',
      returnToDifferentLocation: false
    });
    setSelectedVehicle(null);
    setQuoteData(null);
    setBookingDetails({
      selectedInsurances: {},
      additionals: {},
      paymentMethod: 'credit',
      formData: {
        firstName: '',
        lastName: '',
        documentType: 'DNI',
        documentNumber: '',
        street: '',
        number: '',
        postalCode: '',
        country: 'Argentina',
        city: '',
        email: '',
        phone: ''
      }
    });
  }, []);

  const value = useMemo(() => ({
    searchCriteria,
    selectedVehicle,
    quoteData,
    bookingDetails,
    updateSearchCriteria,
    updateSelectedVehicle,
    updateQuoteData,
    updateBookingDetails,
    resetBooking
  }), [
    searchCriteria,
    selectedVehicle,
    quoteData,
    bookingDetails,
    updateSearchCriteria,
    updateSelectedVehicle,
    updateQuoteData,
    updateBookingDetails,
    resetBooking
  ]);

  return (
    <BookingContext.Provider value={value}>
      {children}
    </BookingContext.Provider>
  );
};
